import { useState } from 'react';
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { ModiratorData } from "../../data/ModiratorData";
import { AddModirators } from "../../features/modirators/AddModirators";
import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import { useAdminModirator } from '../../context/Admins/AdminModiratorContext';

import Pagination from "../../utilities/Pagination";
import UserSampleImg from '../../assets/defaults/user0-img.jpg';
import DeleteBtn from "../../components/buttons/DeleteBtn";
import moment from 'moment';
import 'moment/locale/ar'

export default function AdminModirators() {
    const [error, setError] = useState(null);
    const { modirators, setModirators, currentPage, setCurrentPage } = useAdminModirator();
    const { t } = useTranslation();

    moment.locale('ar_SA');
    const allModiratorsData = modirators?.data?.result;
    const totalPages = modirators?.data?.paginationInfo.totalPagesCount;

    async function handleUserDelete(id) {

        try {
            await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/users/${id}`, { method: "DELETE" });
            const updatedUserData = {
                ...modirators,
                data: {
                    ...modirators.data,
                    result: allModiratorsData.filter((modirator) => modirator.id !== id)
                }
            };
            setModirators(updatedUserData);
            // setDataUpdate(true);
            toast.warn("تم الحذف بنجاح");
            setTimeout(() => {
                window.location.reload();
            }, 3000);

        } catch (err) {
            setError("هناك مشكلة في الحذف");
        }
    }


    const Avatar = ({ firstName, lastName, email, mobilePhone, role, image, id }) => (
        <div className="modireator-avatar d-flex flex-column align-items-center m-2 text-center bg-white rounded-3 position-relative">
            <DeleteBtn
                handleOnClick={() => handleUserDelete(id)}
                t={t}
            />
            {/* <div> */}
            {/* <Popup trigger={ */}
            <img crossOrigin="anonymous" src={image ? image : UserSampleImg} className="avatar-img p-2" alt={`${role}_${id}_Img`}
                data-bs-toggle="modal"
                data-bs-target={`#edit-moderator${id}`}
            />
            {/* } position="bottom left" modal> */}
            {/* </Popup> */}
            {/* </div> */}
            <div className="mt-1">{firstName}</div>
            <div className="c-lightBeige">{role}</div>
            <ModiratorData
                id={id}
                userImage={image}
                firstName={firstName}
                lastName={lastName}
                role={role}
                mobilePhone={mobilePhone}
                email={email}
                UserSampleImg={UserSampleImg}
            />
        </div>
    );

    if (error) return <div className="text-center my-4 text-danger">{error}</div>;
    if (!modirators) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;

    return (
        <>
            <div className="container my-3 rounded bg-light-gray position-relative p-3">
                <div className="d-flex flex-wrap flex-column flex-md-row justify-content-center p-2">
                    {allModiratorsData.map((modirator) => (
                        <Avatar key={modirator.id} id={modirator.id} image={modirator.image}
                            firstName={modirator.firstName} lastName={modirator.lastName} role={modirator.role} mobilePhone={modirator.mobilePhone} email={modirator.email} />
                    ))}
                    <div className="add-modirator d-flex justify-content-center align-items-center rounded-3 bg-white my-2 mx-auto m-md-2 fs-1 c-darkGray"
                        data-bs-toggle="modal"
                        data-bs-target="#add-moderator">
                        +
                    </div>
                </div>
            </div>
            {totalPages > 1 &&
                <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages} />
            }
            <AddModirators />
        </>
    )
}